import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'Guía Maestra Digital (PDF)',
    desc: 'El paso a paso exacto para aplicar el protocolo de 3 días.'
  }, {
    title: 'Tabla de Ventanas de Sueño',
    desc: 'Los horarios exactos según la edad de tu bebé para evitar el sobre-cansancio.'
  }, {
    title: 'Manual "Cueva de Sueño"',
    desc: 'Cómo optimizar el cuarto con productos básicos de tiendas en USA (Walmart/Target).'
  }, {
    title: 'Protocolo de Crisis',
    desc: 'Qué hacer exactamente cuando salen los dientes, hay viajes o regresiones de crecimiento.'
  }, {
    title: 'Diario de Progreso',
    desc: 'Una hoja de seguimiento para ver cómo tu bebé pasa de despertarse 5 veces a 1 sola (o ninguna) en una semana.'
  }];
  return <section className="py-24 px-4 bg-cream-50 text-navy-900" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-204">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-navy-950 mb-4" data-id="element-205">
            Lo que recibes hoy
          </h2>
          <p className="text-lg text-navy-700 font-body max-w-2xl mx-auto" data-id="element-206">
            Todo lo que necesitas para transformar las noches de tu familia, sin
            relleno, directo a la acción.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-207">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-cream-200 flex items-start space-x-4 ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-208">
              <CheckCircleIcon className="w-8 h-8 text-amber-500 flex-shrink-0" data-id="element-209" />
              <div data-id="element-210">
                <h3 className="text-xl font-display font-bold text-navy-900 mb-2" data-id="element-211">
                  {item.title}
                </h3>
                <p className="text-navy-700 font-body leading-relaxed" data-id="element-212">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}